// Per-model provider-specific settings that OpenRouter's models API does not
// expose (e.g. MAI-Transcribe 2's transcribeStyle, which lives in
// provider.options.azure.enhancedMode.modelOptions).
//
// This is NOT a model catalog. The model LIST is fetched live from
// OpenRouter's public /models endpoint (see apps/api/src/lib/openrouter.ts
// fetchModels) on every Settings page open. This map only adds known
// per-model configurable settings for models that have provider-specific
// options beyond what OpenRouter normalizes (temperature, language,
// response_format).
// Only models with known provider-specific options. Other models (Whisper,
// Scribe, gpt-4o-transcribe, etc.) get no conditional settings — OpenRouter
// docs note mai-transcribe-1.5 and gpt-4o-transcribe REJECT verbose/provider
// options, so provider options must stay strictly scoped to mai-transcribe-2.
export const MODEL_SETTINGS = {
    "microsoft/mai-transcribe-2": [
        {
            key: "transcribeStyle",
            label: "Transcription Style",
            type: "select",
            options: [
                { value: "clean", label: "Clean — removes fillers, auto-formats speech" },
                { value: "verbatim", label: "Verbatim — exact spoken words including fillers" },
            ],
            defaultValue: "clean",
            description: "Clean removes 'um', 'uh', false starts and auto-formats. Verbatim preserves everything spoken.",
        },
    ],
};
export function getModelSettings(slug) {
    return MODEL_SETTINGS[slug] ?? [];
}
//# sourceMappingURL=ai-models.js.map